import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import { Autocomplete } from '@material-ui/lab';
import Badge from 'components/Badge/Badge';
import ModalOpe from './ModalOpe/ModalOpe';
import { wsFindBy } from 'services/WService';
import moment from 'moment';

const paymentMethods = [
  { value: '001', text: 'Depósito en cuenta' },
  // { value: '002', text: 'Giro' },
  { value: '003', text: 'Transferencia de fondos' },
  // { value: '004', text: 'Orden de pago' },
  // { value: '005', text: 'Tarjeta de débito' },
  // { value: '006', text: 'Tarjeta de crédito' },
  // {
  //   value: '007',
  //   text:
  //     'Cheques con la cláusula de No Negociable, Intransferibles, No a la Orden u otra equivalente, a que se refiere el inciso f) del articulo 5° del decreto legislativo.',
  // },
  // {
  //   value: '008',
  //   text: 'Efectivo, por operaciones en las que no existe obligación de utilizar medios de pago',
  // },
  // { value: '009', text: 'Efectivo, en los demás casos' },
  // { value: '010', text: 'Medios de pago de comercio exterior' },
  // { value: '011', text: 'Letras de cambio' },
  // {
  //   value: '012',
  //   text:
  //     'Documentos emitidos por las edpymes y las cooperativas de ahorro y crédito no autorizadas a captar depósitos del público',
  // },
  // {
  //   value: '013',
  //   text:
  //     'Tarjeta de crédito emitida en el país o en el exterior por una empresa no perteneciente al sistema financiero, cuyo objeto principal sea la emisión y administración de tarjetas de crédito',
  // },
  // {
  //   value: '014',
  //   text:
  //     'Tarjetas de crédito emitidas en el exterior por empresas bancarias o financieras no domiciliadas',
  // },
  // { value: '101', text: 'Transferencias - comercio exterior' },
  // { value: '102', text: 'Cheques bancarios  - comercio exterior' },
  // { value: '103', text: 'Orden de pago simple  - comercio exterior' },
  // { value: '104', text: 'Orden de pago documentario  - comercio exterior' },
  // { value: '105', text: 'Remesa simple  - comercio exterior' },
  // { value: '106', text: 'Remesa documentaria  - comercio exterior' },
  // { value: '107', text: 'Carta de crédito simple  - comercio exterior' },
  // { value: '108', text: 'Carta de crédito documentario  - comercio exterior' },
  // { value: '999', text: 'Otros medios de pago' },
];

function NewDepositHeader(props) {
  const { importData = undefined, deposit, setDeposit, isDisabled, process, onImport, accountSap, bankAccounts } = props;
  const { depositId, originAccounts, selectionModel } = props;
  const { DataOperation, setDataOperation, taxDates, setTaxDates, saveDeposit } = props;
  const { validateOperation, validateExtracto } = props;

  const [processing, setProcessing] = useState(false);
  const [zonesValidated, setZonesValidated] = useState(false);
  const [OpenModalOpe, setOpenModalOpe] = useState(false);

  async function handleProcess() {
    if (processing || props.processing) return;
    setProcessing(true);
    await process();
    setProcessing(false);
  }

  function handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    if (name === 'DeposType') {
      if (value === 'K') {
        setDeposit((deposit) => ({ ...deposit, LocTotal: 0 }));
      }
    }

    setDeposit((deposit) => ({ ...deposit, [name]: value }));
  }

  function validateZones() {
    let bankAccount = bankAccounts.find((item) => item.AcctCode === deposit.BanckAcct);
    let sourceAccounts = deposit.U_SYP_MPPG === '003' ? bankAccounts : originAccounts;
    let originAccount = sourceAccounts.find((item) => item.AcctCode === deposit.AllocAcct);
    if (!bankAccount || !originAccount) return;

    let bankZones = bankAccount.ExportCode.split(',');
    let originZones = originAccount.ExportCode.split(',');

    let includes = false;
    for (let zone of bankZones) {
      if (originZones.includes(zone)) {
        includes = true;
        break;
      }
    }

    setZonesValidated(includes);
    if (!includes) {
      alert('Ojo, no coinciden las zonales');
    }
  }

  useEffect(() => {
    if (bankAccounts.length === 0 || originAccounts.length === 0) return;
    if (deposit.BanckAcct === undefined || deposit.AllocAcct === undefined) return;
    // Solo validar si es un nuevo deposito
    if (depositId !== '0') return;
    validateZones();
  }, [bankAccounts, originAccounts, deposit.BanckAcct, deposit.AllocAcct]);


  useEffect(() => {
    if (taxDates.length > 0) {
      const query = taxDates.map(date => `dateDocument[]=${encodeURIComponent(date)}`).join('&');
      wsFindBy(`pymt/deposit/index-operation?${query}`)
        .then(res => setDataOperation(res.data));
    }
  }, [taxDates]);

  function fetchOperationsByTaxDates() {
    const fechas = [...new Set(importData.map(item => item.TaxDate).filter(Boolean))];
    const query = fechas.map(date => `dateDocument[]=${encodeURIComponent(date)}`).join('&');
    wsFindBy(`pymt/deposit/index-operation?${query}`)
      .then(res => setDataOperation(res.data));
  }


  if(importData !== undefined){
    return (
      <GridContainer>
        {OpenModalOpe && (
          <ModalOpe
            open={OpenModalOpe} 
            onClose={() => 
              setOpenModalOpe(false)
            }
            importDataOperation={DataOperation}
            // reload={reload}
            />
        )}
        {/* BanckAcct */}
        {/* <GridItem xs={12} sm={6} md={4} xl={3}>
          <Autocomplete
            disabled={isDisabled}
            fullWidth
            renderInput={(params) => <TextField {...params} label="Cuenta destino" />}
            options={bankAccounts}
            getOptionLabel={(option) => {
              if (option === null) return '';
              return `${option.AcctCode} - ${option.AcctName}`;
            }}
            value={bankAccounts.find((account) => account.AcctCode === deposit.BanckAcct) || null}
            onChange={(e, item) => {
              if (item === null) {
                setDeposit((deposit) => ({
                  ...deposit,
                  BanckAcct: undefined,
                  CtaDestino: undefined,
                }));
                return;
              }
              setDeposit((deposit) => ({
                ...deposit,
                BanckAcct: item.AcctCode,
                CtaDestino: item.AcctName,
              }));
            }}
          />
        </GridItem> */}
        <GridItem xs={12} sm={6} md={4} xl={3}>
          <Autocomplete
            disabled={isDisabled}
            fullWidth
            renderInput={(params) => <TextField {...params} label="Cuenta origen" />}
            options={originAccounts}
            getOptionLabel={(option) => {
              if (option === null) return '';
              return `${option.AcctCode} - S/${parseFloat(option.CurrTotal).toFixed(2)} - ${
                option.AcctName
              }`;
            }}
            value={originAccounts.find((account) => account.AcctCode === deposit.AllocAcct) || null}
            onChange={(e, item) => {
              if (item === null) {
                setDeposit((deposit) => ({
                  ...deposit,
                  AllocAcct: undefined,
                  CtaOrigen: undefined,
                }));
                return;
              }
              setDeposit((deposit) => ({
                ...deposit,
                AllocAcct: item.AcctCode,
                CtaOrigen: item.AcctName,
              }));
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={4} xl={3}>
          <TextField
            disabled={isDisabled}
            label="Fecha de contabilización"
            type="date"
            fullWidth
            name="DeposDate"
            value={deposit.DeposDate}
            onInput={handleChange}
            inputProps={{
              max: moment().format("YYYY-MM-DD"),
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={4} xl={3}>
          <Button
            fullWidth
            color="success"
            onClick={saveDeposit}
            disabled={
              // !zonesValidated ||
              selectionModel.length === 0 ||
              // !deposit.BanckAcct ||
              processing || props.processing ||
              !validateExtracto ||
              !deposit.AllocAcct
            }
          >
            {/* Agregar Seleccionados */}
            Procesar
          </Button>
        </GridItem>
        <GridItem xs={3}>
          <Button color="warning" onClick={fetchOperationsByTaxDates}>
            Actualizar datos de extracto bancario
          </Button>
        </GridItem>

        {DataOperation && (
          <>
            <GridItem xs={3}>
              <Button
                fullWidth
                color="info"
                disabled={!DataOperation || accountSap.length === 0}
                onClick={() => setOpenModalOpe(true)}
              >
                Mostrar operaciones de extracto bancario
              </Button>
            </GridItem>
            <GridItem xs={3}>
              <Button
                fullWidth
                color="primary"
                disabled={processing || props.processing}
                onClick={validateOperation}
              >
                Validar extracto bancario
              </Button>
            </GridItem>
          </>
        )}
      </GridContainer>
    );
  }

  return (
    <GridContainer>
      {/* DeposType */}
      <GridItem xs={6} sm={4} md={2}>
        <FormControl fullWidth disabled={isDisabled}>
          <InputLabel>Tipo</InputLabel>
          <Select value={deposit.DeposType} name="DeposType" onChange={handleChange}>
            <MenuItem value="C">Efectivo</MenuItem>
            <MenuItem value="K">Cheque</MenuItem>
          </Select>
        </FormControl>
      </GridItem>

      {/* DeposDate */}
      <GridItem xs={6} sm={4} md={3}>
        <TextField
          label="Fecha de contabilización"
          disabled={isDisabled}
          type="date"
          fullWidth
          value={deposit.DeposDate}
          name="DeposDate"
          onInput={handleChange}
          inputProps={{
            max: moment().format("YYYY-MM-DD"),
          }}
        />
      </GridItem>

      <GridItem xs={6} sm={4} md={3}>
        <TextField
          label="Fecha de depósito"
          disabled={isDisabled}
          type="date"
          fullWidth
          value={deposit.TaxDate}
          name="TaxDate"
          onInput={handleChange}
          inputProps={{
            max: moment().format("YYYY-MM-DD"),
          }}
        />
      </GridItem>

      {/* BanckAcct */}
      <GridItem xs={6} md={4}>
        <Autocomplete
          disabled={isDisabled}
          fullWidth
          renderInput={(params) => <TextField {...params} label="Cuenta destino" />}
          options={bankAccounts}
          getOptionLabel={(option) => {
            if (option === null) return '';
            return `${option.AcctCode} - ${option.AcctName}`;
          }}
          value={bankAccounts.find((account) => account.AcctCode === deposit.BanckAcct) || null}
          onChange={(e, item) => {
            if (item === null) {
              setDeposit((deposit) => ({ ...deposit, BanckAcct: undefined }));
              return;
            }
            setDeposit((deposit) => ({ ...deposit, BanckAcct: item.AcctCode }));
          }}
        />
      </GridItem>

      {/* DpsBank */}
      <GridItem xs={3}>
        <TextField
          label="Banco"
          disabled={isDisabled}
          fullWidth
          value={deposit.DpsBank}
          name="DpsBank"
          onInput={handleChange}
        />
      </GridItem>

      {/* Ref2 */}
      <GridItem xs={3}>
        <TextField
          label="Referencia"
          disabled={isDisabled}
          fullWidth
          value={deposit.Ref2}
          name="Ref2"
          onInput={handleChange}
        />
      </GridItem>

      {/* LocTotal */}
      <GridItem xs={3}>
        <TextField
          label="Monto"
          type="number"
          disabled={isDisabled || deposit.DeposType === 'K'}
          fullWidth
          value={parseFloat(deposit.LocTotal)}
          name="LocTotal"
          onInput={handleChange}
          inputProps={{
            min: 0.01,
            step: 0.01,
          }}
        />
      </GridItem>

      {/* U_SYP_MPPG */}
      <GridItem xs={3}>
        <Autocomplete
          disabled={isDisabled}
          fullWidth
          renderInput={(params) => <TextField {...params} label="Método de pago" />}
          options={paymentMethods}
          getOptionLabel={(option) => {
            if (option === null) return '';
            return `${option.value} - ${option.text}`;
          }}
          value={paymentMethods.find((item) => item.value === deposit.U_SYP_MPPG) || null}
          onChange={(e, item) => {
            if (item === null) {
              setDeposit((deposit) => ({
                ...deposit,
                U_SYP_MPPG: undefined,
                AllocAcct: undefined,
                CtaOrigen: undefined,
              }));
              return;
            }
            setDeposit((deposit) => ({
              ...deposit,
              U_SYP_MPPG: item.value,
              ...(deposit.U_SYP_MPPG !== item.value && {
                AllocAcct: undefined,
                CtaOrigen: undefined,
              }),
            }));
          }}
        />
      </GridItem>

      {/* Descripción deposito */}
      <GridItem xs={6}>
        <TextField
          label="Descripción deposito"
          disabled={isDisabled}
          fullWidth
          value={deposit.Memo}
          name="Memo"
          onInput={handleChange}
        />
      </GridItem>

      {!isDisabled && (
        <>
          <GridItem xs={3}>
            <Button
              fullWidth
              color="success"
              disabled={processing || props.processing}
              onClick={onImport}
            >
              Importar excel
            </Button>
          </GridItem>
          <GridItem xs={3}>
            <Button
              fullWidth
              color="success"
              onClick={handleProcess}
              disabled={processing || props.processing}
            >
              Procesar
            </Button>
          </GridItem>
        </>
      )}

      {isDisabled && deposit.DeposId !== undefined && (
        <GridItem xs={3}>
          <Badge color={deposit.DeposId === null ? 'danger' : 'success'}>
            {deposit.DeposId === null ? 'No procesado' : 'Procesado'}
          </Badge>
        </GridItem>
      )}
    </GridContainer>
  );
}

export default NewDepositHeader;
